export default __webpack_public_path__ + "static/media/sContract.c5490e1b.png";